/**
 * オーダーの状況
 */
export const OrderStatus = {
    /**
     * 受付中
     */
    Accepting: "Accepting",
    /**
     * 注文済み
     */
    Order: "Order",
    /**
     * 配送物の集荷待ち
     */
    WaitingForPickup: "WaitingForPickup",
    /**
     * 配送物を集荷して飛行準備中の状態
     */
    InPreparation: "InPreparation",
    /**
     * もうすぐ到着（5分目安）
     */
    ArrivingSoon: "ArrivingSoon",
    /**
     * 飛行中
     */
    InFlight: "InFlight",
    /**
     * 到着
     */
    Arrivaled: "Arrivaled",
    /**
     * 戻りフライト準備中
     */
    ReturnInPreparation: "ReturnInPreparation",
    /**
     * 戻りフライト中
     */
    ReturnInFlight: "ReturnInFlight",
    /**
     * 戻り到着直前
     */
    ReturnArrivingSoon: "ReturnArrivingSoon",
    /**
     * 戻り到着
     */
    ReturnArrivaled: "ReturnArrivaled",
    /**
     * 完了
     */
    Completed: "Completed",
    /**
     * キャンセル
     */
    Canceled: "Canceled",
} as const;
export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];
